import React, { ComponentProps, useState, Fragment } from 'react'
import { CSSTransition } from 'react-transition-group'
import { MobileOnly } from '@components/MediaQuery'
import { Button } from '@components/Button'
import { ScreenReaderContent } from '@components/A11y'
import { HamburgerMenuIcon, CloseIcon } from '@components/Icons'
import { AccordionNav } from './AccordionNav'
import {
  PublicMobileMenuWrapper,
  CloseText,
  FadeInWrapper,
  ButtonContent,
  CloseIconWrapper,
  HamburgerIconWrapper,
  TRANSITION_DELAY,
} from './PublicMobileMenu.elements'

type Props = ComponentProps<typeof AccordionNav>

export const PublicMobileMenu = (props: Props) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const handleToggle = () => {
    setIsOpen(!isOpen)
  }

  return (
    <PublicMobileMenuWrapper>
      <MobileOnly>
        <div>
          <Button
            circled={!isOpen}
            variant="text"
            onClick={handleToggle}
          >
            <ButtonContent>
              {isOpen ? (
                <Fragment>
                  <CloseText>Close</CloseText>
                  <CloseIconWrapper>
                    <CloseIcon />
                  </CloseIconWrapper>
                </Fragment>
              ) : (
                <Fragment>
                  <ScreenReaderContent>
                    Open menu
                  </ScreenReaderContent>
                  <HamburgerIconWrapper>
                    <HamburgerMenuIcon />
                  </HamburgerIconWrapper>
                </Fragment>
              )}
            </ButtonContent>
          </Button>
        </div>

        <CSSTransition
          in={isOpen}
          appear
          timeout={TRANSITION_DELAY}
        >
          {state => (
            <FadeInWrapper state={state}>
              {state !== 'exited' && (
                <AccordionNav {...props} />
              )}
            </FadeInWrapper>
          )}
        </CSSTransition>
      </MobileOnly>
    </PublicMobileMenuWrapper>
  )
}
